import useBundleTranslation from 'i18n';
import FormConfirmationFooter from 'components/common/form/confirmation/FormConfirmationFooter';
import { ConfirmationContentProps } from 'components/common/form/confirmation/index';
import { Box } from '@mui/material';

export default function Text({ onConfirm, onCancel, message }: ConfirmationContentProps & { message: string }) {
    const { t } = useBundleTranslation(['form_errors']);
    return (
        <>
            <Box dangerouslySetInnerHTML={{ __html: t(message) }} />
            <FormConfirmationFooter onConfirm={onConfirm} onCancel={onCancel} />
        </>
    );
}
